// Same rules as WideBadge.Shared PhoneNumbers: a 1-3 digit country code (no leading 0) + a 10 digit number.
// Display "+(44) 123 456 78 90", sent/stored as "+441234567890".

export const DEFAULT_COUNTRY_CODE = "44";
export const NATIONAL_DIGITS = 10;

export const digits = (value: string | null | undefined) => (value ?? "").replace(/\D/g, "");

/** "123 456 78 90" grouping of the national part while typing. */
export function formatNational(value: string) {
  const d = digits(value).slice(0, NATIONAL_DIGITS);
  const groups = [d.slice(0, 3), d.slice(3, 6), d.slice(6, 8), d.slice(8, 10)].filter(Boolean);
  return groups.join(" ");
}

/** "+441234567890" → { countryCode: "44", national: "1234567890" }. */
export function splitPhone(value: string | null | undefined) {
  const d = digits(value);
  if (d.length > NATIONAL_DIGITS) {
    return { countryCode: d.slice(0, d.length - NATIONAL_DIGITS), national: d.slice(-NATIONAL_DIGITS) };
  }
  return { countryCode: DEFAULT_COUNTRY_CODE, national: d };
}

/** null when no national digits were entered. */
export function normalizePhone(countryCode: string, national: string): string | null {
  const n = digits(national);
  if (!n) return null;
  return `+${digits(countryCode)}${n}`;
}

/** Validation message or null. */
export function validatePhone(countryCode: string, national: string, required: boolean): string | null {
  const c = digits(countryCode);
  const n = digits(national);
  if (!n) return required ? "Enter your phone number." : null;
  if (c.length < 1 || c.length > 3 || c.startsWith("0")) return "Enter a 1–3 digit country code (e.g. 44).";
  if (n.length !== NATIONAL_DIGITS) return "Enter a 10 digit phone number.";
  return null;
}

export function displayPhone(value: string | null | undefined) {
  if (!value) return "—";
  const { countryCode, national } = splitPhone(value);
  return national.length === NATIONAL_DIGITS ? `+(${countryCode}) ${formatNational(national)}` : value;
}
